export default __webpack_public_path__ + "static/sad-af6abebad8b9b9bad309206294963355.png";